import Flatpickr from 'stimulus-flatpickr'
import monthSelect from 'flatpickr/dist/plugins/monthSelect';
import { Japanese } from 'flatpickr/dist/l10n/ja.js'
import 'flatpickr/dist/plugins/monthSelect/style.css'

export default class extends Flatpickr {
  connect() {
    this.config = {
      locale: Japanese,
      plugins: [
        new monthSelect({
          dateFormat: "Y年m月",
        })
      ]
    }

    super.connect();
  }
}
